import axios from 'axios';

const API_ENDPOINT = 'https://api.themoviedb.org/3';
const API_KEY = '13bfcd7b1d39d829014a5a26d72eaee0';

function ActorLookup(URL) {
    return axios.get(`${API_ENDPOINT}${URL}?api_key=${API_KEY}`);
}

function URLQuery(URL) {
    return `${API_ENDPOINT}${URL}&api_key=${API_KEY}`;
}

export { ActorLookup, URLQuery };
